import { render, staticRenderFns } from "./UserLayoutRight.vue?vue&type=template&id=2677720e&scoped=true&"
import script from "./UserLayoutRight.vue?vue&type=script&lang=js&"
export * from "./UserLayoutRight.vue?vue&type=script&lang=js&"
import style0 from "./UserLayoutRight.vue?vue&type=style&index=0&id=2677720e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677720e",
  null
  
)

export default component.exports